var map = {
	"./beige/akzonobel.svg": 2370,
	"./blue/akzonobel.svg": 2371,
	"./cetabever/akzonobel.svg": 2372,
	"./heritage/akzonobel.svg": 2373,
	"./painters/akzonobel.svg": 2374,
	"./woodcare/akzonobel.svg": 2375
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 561;



//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/assets ^\.\/.*\/akzonobel\.svg$
// module id = 561
// module chunks = 0